import type { RouteObject } from 'react-router';

import { Layout } from '../components';
import { BrandFilters } from '../pages/BrandFilters/BrandFilters';
import { Filters } from '../pages/Filters/Filters';
import { TerpeneFilters } from '../pages/TerpeneFilters/TerpeneFilters';

const baseFilterRoute: RouteObject = {
  element: <Filters />,
  index: true,
};

const brandFiltersRoute: RouteObject = {
  element: <BrandFilters />,
  path: `brand`,
};

const terpeneFiltersRoute: RouteObject = {
  element: <TerpeneFilters />,
  path: `compound_names`,
};

export const filterRoutes: RouteObject = {
  children: [baseFilterRoute, brandFiltersRoute, terpeneFiltersRoute],
  element: <Layout />,
  path: `filters`,
};
